import { createUseStyles } from 'react-jss';
import React, { FC, Fragment } from 'react';
import { capitalize, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import CreatorLink from './CreatorLink';
import { formatDate } from '../../../../../utils/DateUtils';
import SmileIcon from '../../../../../images/smile-avatar.png';
import Contact from '../../../../../interfaces/api/Contact';
import getUrgencyLabel from '../utils/getUrgencyLabel';
import Attachment from './Attachment';

interface Props {
  message?: string;
  urgency?: number;
  attachmentsIds?: string[];
  creator?: Contact;
  createdAt?: string;
  loading?: boolean;
}

const useStyles = createUseStyles({
  itemMessage: {
    padding: 25,
    border: '1px solid #999999',
    borderRadius: '20px 20px 20px 0',
    lineHeight: '21px',
    width: 'calc(100% - 120px)',
    marginLeft: 70,
    marginBottom: 35,
    position: 'relative',
    '&:before': {
      content: `''`,
      position: 'absolute',
      bottom: 0,
      left: -70,
      display: 'block',
      width: 60,
      height: 60,
      borderRadius: 100,
      background: `transparent url('${SmileIcon}') no-repeat center`,
      backgroundSize: '90%',
    },
  },
  files: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 15,
  },
  meta: {
    fontSize: 12,
    marginTop: 10,
  },
});

const CustomerMessage: FC<Props> = ({ message, attachmentsIds, urgency, creator, createdAt, loading }) => {
  const classes = useStyles();

  return (
    <div className={classes.itemMessage}>
      {!loading ? (
        <Typography variant='body1'>
          Niveau d'urgence: {getUrgencyLabel(urgency || 0)}
          <br />
          {message?.split('\n').map((text, key) => (
            <Fragment key={key}>
              {text}
              <br />
            </Fragment>
          ))}
        </Typography>
      ) : (
        <Skeleton height={100} />
      )}

      <div className={classes.files}>
        {attachmentsIds?.map((documentId) => (
          <Attachment documentId={documentId} key={documentId} />
        ))}
      </div>

      {!loading ? (
        <div className={classes.meta}>
          <em>
            <CreatorLink creatorId={creator?.id} creatorName={`${creator?.firstname} ${creator?.lastname}`} />
            {capitalize(formatDate(createdAt, 'YYYY-MM-DDTHH:mm:ss', 'dddd DD MMMM [à] H[h]mm'))}
          </em>
        </div>
      ) : (
        <Skeleton width={300} />
      )}
    </div>
  );
};

export default CustomerMessage;
